import { MultipalIcons } from "assets/icons/index";
import PropTypes from "prop-types";
import {
  ButtonStyleContainer,
  IntroductionContainer,
} from "./SnaptradeModal.styles";

const StepIntroduction = ({ show, onHide, onNext }) => {
  return (
    <IntroductionContainer show={show} onHide={onHide}>
      <div className="content-wrapper">
        <div className="multipal-icons">
          <img src={MultipalIcons} alt="multipal Ions" />
        </div>
        <h2>Link your portfolio to Surmount</h2>
        <p>
          Connect securely to your broker via Plaid to view your portfolio
          confidently. Surmount has read-only access, keeping your account
          unchanged. Your data is yours, ensuring complete control.
        </p>

        <ButtonStyleContainer>
          <button className="btn next-button " onClick={onNext}>
            Next Step
          </button>
        </ButtonStyleContainer>
      </div>
    </IntroductionContainer>
  );
};

StepIntroduction.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onNext: PropTypes.func,
};

export default StepIntroduction;
